import { apiGet, apiPost, apiPut, apiDelete } from '@/services/api/apiClient';
import {
  CreateJobCategoryRequest,
  UpdateJobCategoryRequest,
  JobCategoryListParams,
  JobCategoryResponse,
  JobCategoryListResponse,
} from '@/constants/types';

export const jobCategoryService = {
  async getJobCategories(params?: JobCategoryListParams): Promise<JobCategoryListResponse> {
    const searchParams = new URLSearchParams();
    
    if (params?.search) searchParams.append('search', params.search);
    if (params?.isActive !== undefined) searchParams.append('isActive', params.isActive.toString());
    if (params?.page) searchParams.append('page', params.page.toString());
    if (params?.limit) searchParams.append('limit', params.limit.toString());
    if (params?.sort) searchParams.append('sort', params.sort);

    return await apiGet<JobCategoryListResponse>(`/jobcategory?${searchParams.toString()}`);
  },

  async getJobCategory(id: string): Promise<JobCategoryResponse> {
    return await apiGet<JobCategoryResponse>(`/jobcategory/${id}`);
  },

  async createJobCategory(data: CreateJobCategoryRequest): Promise<JobCategoryResponse> {
    return await apiPost<JobCategoryResponse>('/jobcategory', data);
  },

  async updateJobCategory(id: string, data: UpdateJobCategoryRequest): Promise<JobCategoryResponse> {
    return await apiPut<JobCategoryResponse>(`/jobcategory/${id}`, data);
  },

  async deleteJobCategory(id: string): Promise<{ success: boolean; message: string }> {
    return await apiDelete<{ success: boolean; message: string }>(`/jobcategory/${id}`);
  },
};